import Hotjar from '@hotjar/browser';
const HOTJAR_VERSION = 6;
const initHotjar = () => {
    var _a, _b;
    const hjid = (_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.hjid;
    if (!hjid)
        return;
    Hotjar.init(hjid, HOTJAR_VERSION);
};
export default initHotjar;
